import { render, staticRenderFns } from "./Portafolio.vue?vue&type=template&id=8e4e3914&scoped=true&"
import script from "./Portafolio.vue?vue&type=script&lang=js&"
export * from "./Portafolio.vue?vue&type=script&lang=js&"
import style0 from "./Portafolio.vue?vue&type=style&index=0&id=8e4e3914&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4e3914",
  null
  
)

export default component.exports